<template>
  <svg
    class="sprite-icon"
    v-bind:viewBox="icon.viewBox"
  >
   <use v-bind:xlink:href="icon.url"></use>
  </svg>
</template>

<script>
export default {
  name: 'SvgSpriteIcon',
  props: {
    src: { type: String }
  },
  data: function () {
    return {
      icon: {}
    }
  },
  created () {
    this.icon = require(
      `../../../static/images/sprite-icons/${this.src}.svg`).default
  }
}
</script>

<style scoped>
  .sprite-icon {
    fill: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/SvgSpriteIcon.vue